export const ABOUT_MISSION = 'Build Every Thing Together'
export const ABOUT_PAGE_TITLE = 'About — bldrs.ai'
